import React from "react";
import { useNavigate } from "react-router-dom";
import POSBillingScreen from "../../components/transactions/pos/POSBillingScreen";
import { all_routes } from "../../Router/all_routes";

/**
 * Transactions ▸ POS.
 *
 * The till is a screen rather than a list-plus-modal like the other transaction
 * pages: a cashier lands on it and starts scanning. Bills it saves are ordinary
 * sales invoices (salesTransType 2) numbered in a POS series, so they show up on
 * the Sales Invoice screen and in every sales report alongside web invoices.
 */
const POS = () => {
  const navigate = useNavigate();
  const routes = all_routes;

  const handleExit = (target) => {
    if (target === "salesReturn") {
      navigate(`${routes.POSModule}/Return`);
      return;
    }
    navigate(routes.SalesInvoice);
  };

  return <POSBillingScreen onExit={handleExit} />;
};

export default POS;
